<section id="wrapper" class="error-page">
    <div class="error-box" style="position: static">
        <div class="error-body text-center">
            <h3 class="text-uppercase">Error 403. Acceso no autorizado</h3>
            <img class="img-error img-fluid" src="assets/images/403.jpg" alt="Error 403">
            <p class="text-muted m-t-30 m-b-30">Lo sentimos, la página que estas intentando acceder no se encuentra dentro de los módulos disponibles en tu perfil.</p>
        </div>
    </div>
</section>